import React from "react";
import { LinkTextProps } from "./props";
import { LinkTextContainer } from "./style";

const LinkText = (props: LinkTextProps) => (
  <LinkTextContainer color={props.color} href={props.url} target="_blank">
    {props.label}
  </LinkTextContainer>
);

export default LinkText;
